import { render, staticRenderFns } from "./chemHarmfulRisk.vue?vue&type=template&id=73a035a6"
import script from "./chemHarmfulRisk.vue?vue&type=script&lang=js"
export * from "./chemHarmfulRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a035a6')) {
      api.createRecord('73a035a6', component.options)
    } else {
      api.reload('73a035a6', component.options)
    }
    module.hot.accept("./chemHarmfulRisk.vue?vue&type=template&id=73a035a6", function () {
      api.rerender('73a035a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/hfr/chemHarmfulRisk.vue"
export default component.exports